import type { paths } from "@/autogen/openapi";
import { useAccountStore } from "@/store/stores/account";

import { createClient } from "../openapi";

export const PUBLIC_API_VERSION = `2026-04-01`;

const api = createClient<paths>({
  // We run our testing in Vitest with a Node.js + Happy DOM environment,
  // Node.js normally throws if you instantiate a request with no origin,
  // which I think Happy DOM papers over, but there are some cases where this
  // doesn't seem to work and just throws anyway?
  base: !import.meta.env.VITEST ? "/v1" : "http://localhost:80/v1",
  middlewares: [
    async (request, next) => {
      const { newsletter } = useAccountStore();
      if (newsletter == null) {
        return next(request);
      }

      const url = request.url;

      if (newsletter.stripe_account === "") {
        // This is janky, but the right way to do it for now.
        if (url.includes("/prices") || url.includes("/coupons")) {
          return Response.json({ results: [] }, { status: 209 });
        }
      }

      request.headers.set("authorization", `Token ${newsletter.api_key}`);
      request.headers.set("x-api-version", PUBLIC_API_VERSION);
      return next(request);
    },
  ],
});

export default api;
